import { lighten, styled } from '@mui/material/styles';
import { Alert } from '@mui/material';

export const AVATAR_SIZES = [30, 40, 48, 66, 96];

const StyledAlert = styled(Alert)(({ theme }: any) => ({
  '&.MuiAlert-standard.MuiAlert-colorInfo': {
    backgroundColor: lighten(theme.palette.primary.main, 0.95),
    border: `1px solid ${lighten(theme.palette.primary.main, 0.9)}`,
    color: theme.palette.primary.main,

    '& .MuiAlert-icon': {
      color: theme.palette.primary.main,
    },
  },
}));

export default StyledAlert;
